import { getSupplierOutstandingColumns, getSupplierOutstandingRows } from "./supplier-outstanding-statement";
import { AgingSummary } from "./aging-statement";
import { getSupplierOutstanding, getSupplierOutstandingSummary } from "@/api/finance/reportApi";
import {
  DynamicReport
} from "@/components/dynamic";

// Every supplier unless one is picked; the as-of date comes from the report's date filter.
const supplierOutstandingFilters = {
  SupplierId: "*",
};

const supplierOutstandingFilterOptions = [
  { key: "supplierId", apiKey: "SupplierId" },
];

// Totals over every line that matches the filters, not just the page
// (SupplierOutstandingSummaryReport).
const summaryTiles = [
  { key: "netTotal", label: "Net Outstanding", highlight: true },
  { key: "documentsTotal", label: "Invoices and Credit Notes" },
  { key: "overdueTotal", label: "Overdue", late: true },
  { key: "advancesTotal", label: "Unapplied Advances" },
  { key: "documents", label: "Documents", isCount: true },
  { key: "suppliers", label: "Suppliers", isCount: true },
];

export default function ReportSupplierOutstanding({ activeCompany }) {
  return (
    <DynamicReport
      reportName="supplier-outstanding"
      activeCompany={activeCompany}
      columnsDataProvider={getSupplierOutstandingColumns}
      rowsDataProvider={getSupplierOutstandingRows}
      fetchData={getSupplierOutstanding}
      fetchSummary={getSupplierOutstandingSummary}
      renderSummary={(summary) => <AgingSummary summary={summary} tiles={summaryTiles} />}
      exportUrl="procurement/reports/supplier/outstanding/xls"
      filtersInitialState={supplierOutstandingFilters}
      filterOptions={supplierOutstandingFilterOptions}
      showDateRangeFilter={false}
      showDateFilter
      orderBy="SupplierName"
    />
  );
}
